module.exports = __webpack_public_path__ + "static/media/dk.d6e726a8.svg";